/**
 * @flow
 * @relayHash 108edaa30e207a8bb579020f12c744f0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyTwoFactorInput = {|
  twoFactorToken: string,
  code: string,
  rememberDevice?: ?boolean,
|};
export type VerifyTwoFactorMutationVariables = {|
  input: VerifyTwoFactorInput
|};
export type VerifyTwoFactorMutationResponse = {|
  +verifyTwoFactor: {|
    +user: {|
      +id: string
    |}
  |}
|};
export type VerifyTwoFactorMutation = {|
  variables: VerifyTwoFactorMutationVariables,
  response: VerifyTwoFactorMutationResponse,
|};
*/


/*
mutation VerifyTwoFactorMutation(
  $input: VerifyTwoFactorInput!
) {
  verifyTwoFactor(input: $input) {
    user {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VerifyTwoFactorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "verifyTwoFactor",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyTwoFactorPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "VerifyTwoFactorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "VerifyTwoFactorMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "VerifyTwoFactorMutation",
    "id": null,
    "text": "mutation VerifyTwoFactorMutation(\n  $input: VerifyTwoFactorInput!\n) {\n  verifyTwoFactor(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a379b68963b96b03b8c8ea8c8db8ef90';
module.exports = node;
